<template>
    <div class="news">
        <b-container class="" style="position: relative;">
            <div class=" d-flex align-items-center py-3 sticky-top" style="top: 55px; z-index: 2; background: aliceblue;">
                <b-link class="back btn btn-outline-primary my-auto d-flex align-items-center text-nowrap" style="max-height: 110px !important; " to="news" variant="outline-primary">
                    <b-icon-arrow-left-short style="font-size: 155%;"></b-icon-arrow-left-short> 返回列表
                </b-link>
                <h4 class="title font-weight-bold ml-4 mb-0">{{ IsNull(Item.Title) }}</h4>
            </div>
            
            <div class="detail">
                <div class="d-flex align-items-center justify-content-between">
                    <h5><b-badge variant="primary">{{ IsNull(Item.Type) }}</b-badge></h5>
                    <span class="d-flex align-items-center text-nowrap">
                        <b-icon-clock class="mr-2"></b-icon-clock> {{ Item.Create | datefmt('YYYY-MM-DD') }}
                    </span>
                </div>
                <b-img
                    class="mb-3 w-100" style="max-height: 450px; object-fit: cover; object-position: center;"
                    v-if="Item.Cover != ''"
                    :src="$store.state.WebSite + 'files/_news/' + Item.Id + '/cover.png'"
                    fluid
                >
                </b-img>
                <div class="news_detail_content" v-html="IsNull(Item.Content)"></div>
            </div>
            <loading :data_in="loadSet"></loading>
        </b-container>
    </div>
</template>
<script>
    import { apiGetNews } from '@/api/API.js';
    export default {
        name: 'NewsDetail',
        components: {},
        data() {
            return {
                Item: {},
                Id: '',
            };
        },
        mounted() {
            this.loadSet.show = true;
            if (this.$route.query.id != undefined) {
                this.Id = this.$route.query.id;
                this.Init();
            }
        },
        methods: {
            async Init() {
                apiGetNews(this.Id).then((res) => {
                    this.Item = res.data;
                    this.loadSet.show = false;
                });
            },
        },
    };
</script>
